import api from './api';

export const mailCampaignsService = {
  list: (params?: Record<string, any>) =>
    api.get('/mail-campaigns', { params }).then((r) => r.data),
  getById: (id: number) => api.get(`/mail-campaigns/${id}`).then((r) => r.data),
  create: (data: any) => api.post('/mail-campaigns', data).then((r) => r.data),
  update: (id: number, data: any) => api.put(`/mail-campaigns/${id}`, data).then((r) => r.data),
  addRecipients: (id: number, data: { clients?: number[]; leads?: number[] }) =>
    api.post(`/mail-campaigns/${id}/recipients`, data).then((r) => r.data),
  send: (id: number, scheduledAt?: string) =>
    api.post(`/mail-campaigns/${id}/send`, { scheduledAt }).then((r) => r.data),
  getStatus: (id: number) => api.get(`/mail-campaigns/${id}/status`).then((r) => r.data),
  kanbanAddLead: (data: { productId: number; templateId: number; leadId: number }) =>
    api.post('/mail-campaigns/kanban', data).then((r) => r.data),
  delete: (id: number) => api.delete(`/mail-campaigns/${id}`).then((r) => r.data),
  reanalyzeBounces: (id: number, force = false) =>
    api
      .post(`/mail-campaigns/${id}/reanalyze-bounces`, {}, { params: { force } })
      .then((r) => r.data),
};
